import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=c52e066a&scoped=true"
import script from "./fotter.vue?vue&type=script&lang=js"
export * from "./fotter.vue?vue&type=script&lang=js"
import style0 from "./fotter.vue?vue&type=style&index=0&id=c52e066a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e066a",
  null
  
)

export default component.exports